import billApi from '@/api/billApi'

const SET_ORDER_LIST = 'setOrderList'
const SET_ORDER_COUNT = 'setOrderCount'

const state = {
  orderList: [],
  orderCount: 0,
  incomeCount: 0,
  refundCount: 0,
  income: 0,
  refund: 0
}

// 订单状态 1 支付成功 2 正在出货 3 出货成功 4 出货失败 5 订单异常 已关闭 6 游戏成功 7 游戏失败 8 自动退款 9 手动退款 10 自动部分退款 11 手动部分退款

const getters = {
  incomeSum (state) {
    let income = 0

    state.orderList && state.orderList.forEach(row => {
      if (row.status > 0 && row.status < 8) {
        income += row.total_price
      } else if ([10, 11].indexOf(row.status) !== -1 && [10, 11].indexOf(row.status) !== -1) {
        income += row.total_price - row.refund_fee
      }
    })
    return (income / 100).toFixed(2)
  },
  refundSum (state) {
    let refund = 0

    state.orderList && state.orderList.forEach(row => {
      if (row.status === 8 || row.status === 9 || row.status === 10 || row.status === 11) {
        refund += row.refund_fee
      }
    })
    return (refund / 100).toFixed(2)
  }
}

const mutations = {
  [SET_ORDER_LIST] (state, orderList) {
    state.orderList = orderList
  },
  [SET_ORDER_COUNT] (state, data) {
    state.orderCount = data.count
    state.income = data.income
    state.refund = data.refund
    state.incomeCount = data.income_count
    state.refundCount = data.refund_count
  }
}

const actions = {
  getOrders ({ commit }, data) {
    return new Promise((resolve, reject) => {
      billApi.getOrders(data.page, data.pageSize,
        data.sort, data.filters).then(res => {
        if (res && res.rcode === 0) {
          console.log(res.data)
          commit(SET_ORDER_LIST, res.data.orders)
          commit(SET_ORDER_COUNT, res.data)
          resolve(res)
        } else {
          reject(res)
        }
      }).catch(err => {
        reject(err)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/bill.js